import { RailroadLightIcon } from './RailroadLightIcon';

/**
 * author: Michael Richins
 * id 7FC3FA6E-ED0B-4BCD-AF44-1125CC2CE3C4
 * name railroad-light
 * version: 3.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/railroad-light.svg
 * tags
 * - Transportation + Other 
 */
export const LevelCrossingSignalsIcon = RailroadLightIcon;
export default LevelCrossingSignalsIcon